let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("23fwe")).then(() => parcelRequire('az2Jc'));